var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFortesInteractiveLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 50,
    viewBox: "0 0 125 50",
    fill: "none",
    id: "svg343",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g655",
    transform: "matrix(0.27325344,0,0,0.27325344,54.902406,4.5699784)",
    style: {
      strokeWidth: 3.65962,
      fill: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    },
    transform: "translate(-200.92119,-16.724322)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 123.83,90.39 c -11.85,0 -21.5,-9.64 -21.5,-21.5 0,-11.85 9.64,-21.5 21.5,-21.5 11.85,0 21.5,9.64 21.5,21.5 0,11.85 -9.65,21.5 -21.5,21.5 z m 0,-32.9 c -6.28,0 -11.4,5.11 -11.4,11.4 0,6.29 5.11,11.4 11.4,11.4 6.28,0 11.4,-5.11 11.4,-11.4 0,-6.29 -5.11,-11.4 -11.4,-11.4 z",
    id: "path4",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    },
    transform: "translate(-200.92119,-16.724322)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 162.71,63.9 c -2.25,0 -4.3,-1.51 -4.89,-3.79 -3.19,-12.39 -12.87,-22.05 -25.26,-25.22 -2.7,-0.69 -4.33,-3.44 -3.64,-6.14 0.69,-2.7 3.44,-4.33 6.14,-3.64 15.96,4.09 28.43,16.54 32.54,32.49 0.69,2.7 -0.93,5.45 -3.63,6.15 -0.42,0.1 -0.85,0.15 -1.26,0.15 z",
    id: "path8",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g14",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    },
    transform: "translate(-200.92119,-16.724322)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 123.83,114.08 c -24.92,0 -45.19,-20.27 -45.19,-45.19 0,-20.63 13.94,-38.63 33.9,-43.77 2.69,-0.69 5.45,0.93 6.15,3.63 0.69,2.7 -0.93,5.45 -3.63,6.15 -15.5,3.99 -26.32,17.96 -26.32,33.99 0,19.35 15.74,35.09 35.1,35.09 16.05,0 30.03,-10.84 34,-26.36 0.69,-2.7 3.43,-4.33 6.14,-3.64 2.7,0.69 4.33,3.44 3.64,6.14 -5.12,20 -23.12,33.96 -43.79,33.96 z",
    id: "path12",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g18",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    },
    transform: "translate(-200.92119,-16.724322)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 123.84,137.77 c -34.12,0 -62.74,-24.42 -68.05,-58.07 -0.43,-2.75 1.45,-5.34 4.2,-5.77 2.77,-0.44 5.34,1.45 5.77,4.2 4.53,28.71 28.95,49.55 58.07,49.55 29.12,0 53.54,-20.84 58.06,-49.55 0.44,-2.76 3.03,-4.63 5.77,-4.2 2.76,0.43 4.64,3.02 4.2,5.77 -5.29,33.65 -33.91,58.07 -68.02,58.07 z",
    id: "path16",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    },
    transform: "translate(-200.92119,-16.724322)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 60.78,63.91 c -0.26,0 -0.53,-0.02 -0.79,-0.06 -2.76,-0.43 -4.63,-3.02 -4.2,-5.77 C 61.1,24.42 89.72,0 123.84,0 c 34.11,0 62.72,24.42 68.04,58.06 0.44,2.76 -1.44,5.34 -4.2,5.77 -2.75,0.43 -5.34,-1.44 -5.77,-4.2 -4.53,-28.71 -28.95,-49.54 -58.06,-49.54 -29.12,0 -53.54,20.84 -58.07,49.55 -0.41,2.49 -2.55,4.27 -5,4.27 z",
    id: "path20",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    },
    transform: "translate(-200.92119,-16.724322)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 3.13,156.71 v 24.26 H 0 v -24.26 z",
    id: "path24",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 31.1,180.97 v -24.26 h 3.42 l 7.77,12.27 c 1.8,2.84 3.2,5.4 4.36,7.88 l 0.07,-0.04 c -0.29,-3.24 -0.36,-6.19 -0.36,-9.97 V 156.7 h 2.95 v 24.26 h -3.17 l -7.7,-12.31 c -1.69,-2.7 -3.31,-5.47 -4.54,-8.1 l -0.11,0.04 c 0.18,3.06 0.25,5.97 0.25,10.01 v 10.37 z",
    id: "path26",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 81.9,159.37 h -7.38 v -2.66 h 17.96 v 2.66 h -7.42 v 21.6 H 81.9 Z",
    id: "path28",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 130.25,169.59 h -9.43 v 8.75 h 10.51 v 2.63 h -13.64 v -24.26 h 13.1 v 2.63 h -9.97 V 167 h 9.43 z",
    id: "path30",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 157.9,157.03 c 1.58,-0.32 3.85,-0.5 6.01,-0.5 3.35,0 5.51,0.61 7.02,1.98 1.22,1.08 1.91,2.74 1.91,4.61 0,3.2 -2.02,5.33 -4.57,6.19 v 0.11 c 1.87,0.65 2.99,2.38 3.56,4.9 0.79,3.38 1.37,5.72 1.87,6.66 h -3.24 c -0.4,-0.68 -0.94,-2.77 -1.62,-5.79 -0.72,-3.35 -2.02,-4.61 -4.86,-4.72 h -2.95 v 10.51 h -3.13 z m 3.13,11.05 h 3.2 c 3.35,0 5.47,-1.83 5.47,-4.61 0,-3.13 -2.27,-4.5 -5.58,-4.54 -1.51,0 -2.59,0.14 -3.09,0.29 z",
    id: "path32",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 203.87,173.34 -2.52,7.63 h -3.24 l 8.24,-24.26 h 3.78 l 8.28,24.26 h -3.35 l -2.59,-7.63 z m 7.95,-2.45 -2.38,-6.98 c -0.54,-1.58 -0.9,-3.02 -1.26,-4.43 h -0.07 c -0.36,1.44 -0.76,2.92 -1.22,4.39 l -2.38,7.02 z",
    id: "path34",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 260.89,180.18 c -1.15,0.58 -3.46,1.15 -6.41,1.15 -6.84,0 -11.99,-4.32 -11.99,-12.27 0,-7.6 5.15,-12.74 12.67,-12.74 3.02,0 4.93,0.65 5.76,1.08 l -0.76,2.56 c -1.19,-0.58 -2.88,-1.01 -4.9,-1.01 -5.69,0 -9.47,3.64 -9.47,10.01 0,5.94 3.42,9.75 9.32,9.75 1.91,0 3.85,-0.4 5.11,-1.01 z",
    id: "path36",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 292.93,159.37 h -7.38 v -2.66 h 17.96 v 2.66 h -7.42 v 21.6 h -3.17 v -21.6 z",
    id: "path38",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 331.85,156.71 v 24.26 h -3.13 v -24.26 z",
    id: "path40",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 365.15,180.97 -7.92,-24.26 h 3.38 l 3.78,11.95 c 1.04,3.28 1.94,6.23 2.59,9.07 h 0.07 c 0.68,-2.81 1.69,-5.87 2.77,-9.04 l 4.1,-11.99 h 3.35 l -8.67,24.26 h -3.45 z",
    id: "path42",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 414.97,169.59 h -9.43 v 8.75 h 10.51 v 2.63 H 402.4 v -24.26 h 13.1 v 2.63 h -9.97 V 167 h 9.43 v 2.59 z",
    id: "path44",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m -164.90119,21.675678 c 1.39,0 2.58,0.5 3.57,1.49 0.96,0.99 1.44,2.18 1.44,3.57 0,1.39 -0.5,2.56 -1.49,3.52 -0.96,0.99 -2.14,1.49 -3.52,1.49 h -0.04 -25.65 v 15.41 h 18.51 c 1.39,0 2.58,0.48 3.57,1.44 0.99,0.99 1.49,2.18 1.49,3.57 0,1.39 -0.5,2.58 -1.49,3.57 -0.99,0.96 -2.18,1.44 -3.57,1.44 h -18.51 v 20.47 c 0,1.39 -0.5,2.56 -1.49,3.52 -0.99,0.99 -2.18,1.49 -3.57,1.49 -1.39,0 -2.56,-0.5 -3.52,-1.49 -0.99,-0.96 -1.49,-2.14 -1.49,-3.52 v -50.92 c 0,-1.41 0.5,-2.6 1.49,-3.57 0.96,-0.99 2.14,-1.49 3.52,-1.49 h 0.04 30.71 z",
    id: "path48",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 57.49881,39.385678 c 0,3.74 -1.16,7.12 -3.48,10.15 -2.24,3 -5.18,5.14 -8.83,6.41 l 9.64,19.53 c 0.59,1.22 0.66,2.48 0.21,3.78 -0.42,1.3 -1.26,2.26 -2.5,2.89 -0.71,0.34 -1.44,0.51 -2.21,0.51 -2.07,0 -3.56,-0.93 -4.46,-2.8 l -11.25,-22.8 h -8.62 v 20.25 c 0,1.36 -0.5,2.53 -1.49,3.53 -0.96,0.96 -2.14,1.44 -3.52,1.44 -1.36,0 -2.53,-0.48 -3.52,-1.44 -0.96,-0.99 -1.44,-2.17 -1.44,-3.53 v -50.62 c 0,-1.39 0.48,-2.56 1.44,-3.52 0.99,-0.99 2.17,-1.49 3.52,-1.49 h 17.58 c 5.24,0 9.69,1.73 13.38,5.18 3.69,3.45 5.55,7.63 5.55,12.53 z m -18.6,7.68 c 2.38,-0.08 4.42,-0.86 6.11,-2.34 1.67,-1.5 2.51,-3.28 2.51,-5.35 0,-2.15 -0.88,-3.98 -2.63,-5.48 -1.76,-1.5 -3.86,-2.17 -6.33,-2.17 h -12.57 v 15.33 h 12.91 z",
    id: "path50",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 87.28881,31.735678 h -12.61 c -1.39,0 -2.58,-0.5 -3.57,-1.49 -0.96,-0.96 -1.44,-2.18 -1.44,-3.57 0,-1.39 0.48,-2.56 1.44,-3.52 0.99,-0.99 2.18,-1.49 3.57,-1.49 h 35.29 c 1.36,0 2.53,0.5 3.52,1.49 0.96,0.96 1.44,2.14 1.44,3.52 0,1.38 -0.48,2.6 -1.44,3.57 -0.99,0.99 -2.17,1.49 -3.52,1.49 h -12.65 v 45.9 c 0,1.39 -0.5,2.58 -1.49,3.57 -0.96,0.96 -2.14,1.44 -3.52,1.44 -1.39,0 -2.56,-0.48 -3.52,-1.44 -0.99,-0.99 -1.49,-2.18 -1.49,-3.57 v -45.9 z",
    id: "path52",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 166.10881,72.585678 c 1.39,0 2.56,0.5 3.52,1.49 0.99,0.99 1.49,2.18 1.49,3.57 0,1.39 -0.5,2.56 -1.49,3.52 -0.96,0.99 -2.14,1.49 -3.52,1.49 h -30.74 c -1.39,0 -2.56,-0.5 -3.52,-1.49 -0.99,-0.96 -1.49,-2.14 -1.49,-3.52 v -50.92 c 0,-1.41 0.5,-2.6 1.49,-3.57 0.96,-0.99 2.14,-1.49 3.52,-1.49 h 0.04 30.7 c 1.39,0 2.58,0.5 3.57,1.49 0.96,0.99 1.44,2.18 1.44,3.57 0,1.39 -0.5,2.56 -1.49,3.52 -0.96,0.99 -2.14,1.49 -3.52,1.49 h -0.04 -25.65 v 15.41 h 18.51 c 1.39,0 2.58,0.48 3.57,1.44 0.99,0.99 1.49,2.18 1.49,3.57 0,1.39 -0.5,2.58 -1.49,3.57 -0.99,0.96 -2.18,1.44 -3.57,1.44 h -18.51 v 15.41 h 25.69 z",
    id: "path54",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 227.40881,65.645678 c -0.23,5.07 -2.25,9.36 -6.07,12.87 -3.85,3.51 -8.44,5.27 -13.76,5.27 -4.61,0 -8.75,-0.99 -12.4,-2.97 -4.39,-2.38 -7.18,-5.83 -8.37,-10.36 -0.34,-1.33 -0.17,-2.59 0.51,-3.78 0.71,-1.19 1.73,-1.95 3.06,-2.29 1.33,-0.34 2.59,-0.17 3.78,0.51 1.19,0.71 1.95,1.73 2.29,3.06 0.51,1.9 1.9,3.38 4.16,4.46 2.04,0.93 4.36,1.4 6.96,1.4 2.66,0 4.94,-0.83 6.84,-2.5 1.92,-1.64 2.94,-3.68 3.06,-6.12 0.06,-1.47 -0.53,-3.91 -1.64,-5.07 -1.76,-1.87 -4.7,-2.83 -8.83,-2.89 h -0.04 c -0.11,0 -0.14,0 -0.08,0 -0.03,0 -0.06,0 -0.08,0 -6.94,-0.11 -12.24,-2.11 -15.92,-5.99 -3.03,-3.23 -4.44,-7.75 -4.25,-12.03 0.23,-5.1 2.25,-9.88 6.07,-13.39 3.82,-3.51 8.41,-5.27 13.76,-5.27 4.61,0 8.75,0.99 12.4,2.97 4.38,2.38 7.18,5.83 8.37,10.36 0.34,1.33 0.15,2.59 -0.55,3.78 -0.68,1.19 -1.69,1.95 -3.01,2.29 -1.33,0.34 -2.59,0.17 -3.78,-0.51 -1.19,-0.71 -1.95,-1.73 -2.29,-3.06 -0.51,-1.9 -1.91,-3.38 -4.2,-4.46 -2.01,-0.93 -4.32,-1.4 -6.92,-1.4 -2.66,0 -4.95,0.83 -6.88,2.51 -1.9,1.67 -2.9,4.19 -3.01,6.6 -0.06,1.47 0.47,3.58 1.57,4.77 1.76,1.84 4.7,2.79 8.83,2.84 h 0.21 c 6.94,0.11 12.24,2.12 15.92,6.03 3.01,3.19 4.49,8.07 4.29,12.37 z",
    id: "path56",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g60",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    },
    transform: "translate(-200.92119,-16.724322)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 449.3,43.92 c 0,3.3 -2.59,5.88 -5.95,5.88 -3.33,0 -5.99,-2.59 -5.99,-5.88 0,-3.22 2.66,-5.81 5.99,-5.81 3.36,-0.01 5.95,2.58 5.95,5.81 z m -10.45,0 c 0,2.59 1.91,4.64 4.54,4.64 2.55,0 4.43,-2.06 4.43,-4.61 0,-2.59 -1.88,-4.68 -4.46,-4.68 -2.58,0 -4.51,2.09 -4.51,4.65 z m 3.57,3.04 h -1.35 v -5.81 c 0.53,-0.11 1.28,-0.18 2.23,-0.18 1.1,0 1.59,0.18 2.02,0.43 0.32,0.25 0.57,0.71 0.57,1.28 0,0.64 -0.5,1.13 -1.2,1.35 v 0.07 c 0.57,0.21 0.89,0.64 1.06,1.42 0.18,0.89 0.28,1.24 0.43,1.45 h -1.45 c -0.18,-0.21 -0.28,-0.74 -0.46,-1.42 -0.11,-0.64 -0.46,-0.92 -1.2,-0.92 h -0.64 v 2.33 z m 0.04,-3.29 h 0.64 c 0.74,0 1.35,-0.25 1.35,-0.85 0,-0.53 -0.39,-0.89 -1.24,-0.89 -0.35,0 -0.6,0.04 -0.74,0.07 v 1.67 z",
    id: "path58",
    style: {
      fill: "#ffffff",
      strokeWidth: 3.65962
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs341"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.602,
    height: 49.5468,
    fill: "white",
    id: "rect338"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortesInteractiveLogo);
export default __webpack_public_path__ + "static/media/fortes-interactive-logo.d3aa1e512b47961313f5fddc71a14c56.svg";
export { ForwardRef as ReactComponent };